import React, {Component} from "react";
import {withTranslation} from "react-i18next";
import styles from "../../../../../../../ricercaSegnalazioni/ricercaSegnalazioni.module.css";
import ConfermaDiLaboratorioMorbillo from "./Morbillo/ConfermaDiLaboratorioMorbillo";
import ConfermaDiLaboratorioRosolia from "./Rosolia/ConfermaDiLaboratorioRosolia";
import RadioButton from "../../../../../../../../components/radiobutton/RadioButton";
import Calendar from "../../../../../../../../components/calendar/Calendar";
import Utils from "../../../../../../../../utils/Utils";
import $ from "jquery";

class confermaDiLaboratorio extends Component {

    state = {
        confermaDiLaboratorio: {
            invioCampionePeriferico: "",
            dataInvioCampionePeriferico: "",
            invioCampioneRegionale: "",
            dataInvioCampioneRegionale: "",
            invioCampioneNazionale: "",
            dataInvioCampioneNazionale: "",
        },
        confermaDiLaboratorioMorbillo: {},
        confermaDiLaboratorioRosolia: {},
    }

    constructor(props) {
        super(props);
        this.updateConferme = this.updateConferme.bind(this)
        this.riceviValore = this.riceviValore.bind(this)
        this.createObjectBE = this.createObjectBE.bind(this)
        this.disabledDate = this.disabledDate.bind(this)
        this.validate = this.validate.bind(this)
    }

    componentDidMount() {

        if (this.props.segnalazioneCopia && this.props.segnalazioneCopia.schedaSpeciale && this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio) {
            let confermaDiLaboratorio = this.state.confermaDiLaboratorio
            let confermaDiLaboratorioCopia = this.props.segnalazioneCopia.schedaSpeciale.confermaDiLaboratorio
            for (let key in confermaDiLaboratorio) {
                if (confermaDiLaboratorio.hasOwnProperty(key) === confermaDiLaboratorioCopia.hasOwnProperty(key)) {
                    confermaDiLaboratorio[key] = confermaDiLaboratorioCopia[key]
                } else {
                    confermaDiLaboratorio[key] = ""
                }
            }
            this.setState({confermaDiLaboratorio: confermaDiLaboratorio})
            this.disabledDate()
            let oggettoBE = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("confermaDiLaboratorio", oggettoBE, corretto)
        } else {
            this.disabledDate()
            let oggettoBE = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("confermaDiLaboratorio", oggettoBE, corretto)
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.disabledDate()
        if (prevState !== this.state) {
            let res = this.createObjectBE()
            let corretto = this.controlloCorrettezza()
            this.props.createOggettoBeAndcontrolloCorrettezza("confermaDiLaboratorio", res, corretto, this.validate())
        }
    }

    updateConferme(object) {
        this.setState(object)
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloCorrettezza()
        this.props.createOggettoBeAndcontrolloCorrettezza("confermaDiLaboratorio", oggettoBE, corretto, this.validate())
    }

    validate() {

        if (this.state.confermaDiLaboratorioMorbillo &&
            this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest
            && Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest, "Messages.dataRaccoltaCampioneAltroTest", "Messages.dataRaccoltaCampioneAltroTestOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneAltroTest, "Messages.dataRaccoltaCampioneAltroTest", "Messages.dataRaccoltaCampioneAltroTestOdierna")
        }
        if (this.state.confermaDiLaboratorioMorbillo &&
            this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr
            && Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr, "Messages.dataRaccoltaCampionePcr", "Messages.dataRaccoltaCampionePcrOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampionePcr, "Messages.dataRaccoltaCampionePcr", "Messages.dataRaccoltaCampionePcrOdierna")
        }
        if (this.state.confermaDiLaboratorioMorbillo &&
            this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm
            && Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm, "Messages.dataRaccoltaCampioneRicergaIgm", "Messages.dataRaccoltaCampioneRicergaIgmOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.dataRaccoltaCampioneRicergaIgm, "Messages.dataRaccoltaCampioneRicergaIgm", "Messages.dataRaccoltaCampioneRicergaIgmOdierna")
        }
        if (this.state.confermaDiLaboratorioMorbillo &&
            this.state.confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg
            && Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.primaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")
        }
        if (this.state.confermaDiLaboratorioMorbillo &&
            this.state.confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg
            && Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioMorbillo.secondaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")
        }

        if (this.state.confermaDiLaboratorioRosolia &&
            this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest
            && Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest, "Messages.dataRaccoltaCampioneAltroTest", "Messages.dataRaccoltaCampioneAltroTestOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneAltroTest, "Messages.dataRaccoltaCampioneAltroTest", "Messages.dataRaccoltaCampioneAltroTestOdierna")
        }
        if (this.state.confermaDiLaboratorioRosolia &&
            this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr
            && Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr, "Messages.dataRaccoltaCampionePcr", "Messages.dataRaccoltaCampionePcrOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampionePcr, "Messages.dataRaccoltaCampionePcr", "Messages.dataRaccoltaCampionePcrOdierna")
        }
        if (this.state.confermaDiLaboratorioRosolia &&
            this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm
            && Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm, "Messages.dataRaccoltaCampioneRicergaIgm", "Messages.dataRaccoltaCampioneRicergaIgmOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioRosolia.dataRaccoltaCampioneRicergaIgm, "Messages.dataRaccoltaCampioneRicergaIgm", "Messages.dataRaccoltaCampioneRicergaIgmOdierna")
        }
        if (this.state.confermaDiLaboratorioRosolia &&
            this.state.confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg
            && Utils.validateDate(this.state.confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioRosolia.primaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")
        }
        if (this.state.confermaDiLaboratorioRosolia &&
            this.state.confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg
            && Utils.validateDate(this.state.confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorioRosolia.secondaDataRaccoltaCampioneRicergaIgg, "Messages.primaDataRaccoltaCampioneRicergaIgg", "Messages.primaDataRaccoltaCampioneRicergaIggOdierna")
        }

        if (this.state.confermaDiLaboratorio.dataInvioCampioneNazionale && Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampioneNazionale, "Messages.DataInvio", "Messages.DataInvioOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampioneNazionale, "Messages.DataInvio", "Messages.DataInvioOdierna")
        }
        if (this.state.confermaDiLaboratorio.dataInvioCampionePeriferico && Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampionePeriferico, "Messages.DataInvio", "Messages.DataInvioOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampionePeriferico, "Messages.DataInvio", "Messages.DataInvioOdierna")
        }
        if (this.state.confermaDiLaboratorio.dataInvioCampioneRegionale && Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampioneRegionale, "Messages.DataInvio", "Messages.DataInvioOdierna")) {
            return Utils.validateDate(this.state.confermaDiLaboratorio.dataInvioCampioneRegionale, "Messages.DataInvio", "Messages.DataInvioOdierna")
        }

        return ""

    }

    riceviValore(field, event) {
        let confermaDiLaboratorio = this.state.confermaDiLaboratorio
        confermaDiLaboratorio[field] = event.target.value
        if (confermaDiLaboratorio.invioCampionePeriferico !== "1") {
            confermaDiLaboratorio.dataInvioCampionePeriferico = ""
        }
        if (confermaDiLaboratorio.invioCampioneRegionale !== "1") {
            confermaDiLaboratorio.dataInvioCampioneRegionale = ""
        }
        if (confermaDiLaboratorio.invioCampioneNazionale !== "1") {
            confermaDiLaboratorio.dataInvioCampioneNazionale = ""
        }
        this.setState({confermaDiLaboratorio: confermaDiLaboratorio})
        let oggettoBE = this.createObjectBE()
        let corretto = this.controlloCorrettezza()
        this.props.createOggettoBeAndcontrolloCorrettezza("confermaDiLaboratorio", oggettoBE, corretto)
    }

    createObjectBE() {
        let confermaDiLaboratorioMorbillo = JSON.parse(JSON.stringify(this.state.confermaDiLaboratorioMorbillo))
        let confermaDiLaboratorioRosolia = JSON.parse(JSON.stringify(this.state.confermaDiLaboratorioRosolia))
        let confermaDiLaboratorio = JSON.parse(JSON.stringify(this.state.confermaDiLaboratorio))
        Utils.removeFieldFromObject(confermaDiLaboratorio, "corretto")
        Utils.removeFieldFromObject(confermaDiLaboratorioMorbillo, "corretto")
        Utils.removeFieldFromObject(confermaDiLaboratorioRosolia, "corretto")
        confermaDiLaboratorio["morbillo"] = Utils.removeEmptyValueFromObject(confermaDiLaboratorioMorbillo)
        confermaDiLaboratorio["rosolia"] = Utils.removeEmptyValueFromObject(confermaDiLaboratorioRosolia)
        let res = Utils.removeEmptyValueFromObject(confermaDiLaboratorio)
        return res
    }

    controlloCorrettezza() {
        let confermaDiLaboratorio = this.state.confermaDiLaboratorio


        let corretto = []

        corretto = corretto.concat(Utils.eliminaNullArray(this.state.confermaDiLaboratorioRosolia.corretto))
        corretto = corretto.concat(Utils.eliminaNullArray(this.state.confermaDiLaboratorioMorbillo.corretto))

        if((confermaDiLaboratorio.invioCampioneNazionale === "1" && !confermaDiLaboratorio.dataInvioCampioneNazionale) || (confermaDiLaboratorio.dataInvioCampioneNazionale &&
            Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorio.dataInvioCampioneNazionale), "-"))) corretto[10] = "Campo \"Invio campione al Laboratorio Periferico - Data Invio\" mancante";

        if((confermaDiLaboratorio.invioCampioneRegionale === "1" && !confermaDiLaboratorio.dataInvioCampioneRegionale) || (confermaDiLaboratorio.dataInvioCampioneRegionale &&
            Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorio.dataInvioCampioneRegionale), "-"))) corretto[11] = "Campo \"Invio campione al Laboratorio Regionale - Data Invio\" mancante";

        if((confermaDiLaboratorio.invioCampionePeriferico === "1" && !confermaDiLaboratorio.dataInvioCampionePeriferico) || (confermaDiLaboratorio.dataInvioCampionePeriferico &&
            Utils.isDateInValid(Utils.transformDateForBackend(confermaDiLaboratorio.dataInvioCampionePeriferico), "-"))) corretto[12] = "Campo \"Invio campione al Laboratorio Nazionale - Data Invio\" mancante";

        return corretto
    }

    disabledDate() {
        if (this.state.confermaDiLaboratorio.invioCampionePeriferico !== "1") {
            $(document).ready(function () {
                $("#dataInvioCampionePeriferico").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataInvioCampionePeriferico").datepicker('enable');
            })
        }
        if (this.state.confermaDiLaboratorio.invioCampioneNazionale !== "1") {
            $(document).ready(function () {
                $("#dataInvioCampioneNazionale").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataInvioCampioneNazionale").datepicker('enable');
            })
        }
        if (this.state.confermaDiLaboratorio.invioCampioneRegionale !== "1") {
            $(document).ready(function () {
                $("#dataInvioCampioneRegionale").datepicker('disable');
            })
        } else {
            $(document).ready(function () {
                $("#dataInvioCampioneRegionale").datepicker('enable');
            })
        }
    }

    render() {

        const {t} = this.props

        const questionario = (
            <div style={{marginTop: "1rem"}} className={"container"}>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.invioCampionePeriferico")}
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <RadioButton id={"invioCampionePerifericoSi"} name={"invioCampionePeriferico"}
                                         label={t("SchedaSpecialeMorbillo.si")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.confermaDiLaboratorio.invioCampionePeriferico === "1"}>
                            </RadioButton>
                            <RadioButton id={"invioCampionePerifericoNo"} name={"invioCampionePeriferico"}
                                         label={t("SchedaSpecialeMorbillo.no")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.confermaDiLaboratorio.invioCampionePeriferico === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.dataInvio")}
                            {this.state.confermaDiLaboratorio.invioCampionePeriferico === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataInvioCampionePeriferico"}
                            value={this.state.confermaDiLaboratorio.dataInvioCampionePeriferico}
                            field={"dataInvioCampionePeriferico"}
                            newCalendar={true}
                            disabled={this.state.confermaDiLaboratorio.invioCampionePeriferico === "1" ? false : true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataInvio"))}
                            error={(this.state.confermaDiLaboratorio.dataInvioCampionePeriferico === "" || this.state.confermaDiLaboratorio.dataInvioCampionePeriferico == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.confermaDiLaboratorio.dataInvioCampionePeriferico), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.invioCampioneRegionale")}
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <RadioButton id={"invioCampioneRegionaleSi"} name={"invioCampioneRegionale"}
                                         label={t("SchedaSpecialeMorbillo.si")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.confermaDiLaboratorio.invioCampioneRegionale === "1"}>
                            </RadioButton>
                            <RadioButton id={"invioCampioneRegionaleNo"} name={"invioCampioneRegionale"}
                                         label={t("SchedaSpecialeMorbillo.no")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.confermaDiLaboratorio.invioCampioneRegionale === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.dataInvio")}
                            {this.state.confermaDiLaboratorio.invioCampioneRegionale === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataInvioCampioneRegionale"}
                            value={this.state.confermaDiLaboratorio.dataInvioCampioneRegionale}
                            field={"dataInvioCampioneRegionale"}
                            newCalendar={true}
                            onChange={this.riceviValore}
                            disabled={this.state.confermaDiLaboratorio.invioCampioneRegionale === "1" ? false : true}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataInvio"))}
                            error={(this.state.confermaDiLaboratorio.dataInvioCampioneRegionale === "" || this.state.confermaDiLaboratorio.dataInvioCampioneRegionale == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.confermaDiLaboratorio.dataInvioCampioneRegionale), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
                <div className={"row"} style={{marginTop: "1rem"}}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.invioCampioneNazionale")}
                        </p>
                    </div>
                    <div className={"col-lg-6"}>
                        <div className={"row"}>
                            <RadioButton id={"invioCampioneNazionaleSi"} name={"invioCampioneNazionale"}
                                         label={t("SchedaSpecialeMorbillo.si")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"1"}
                                         checked={this.state.confermaDiLaboratorio.invioCampioneNazionale === "1"}>
                            </RadioButton>
                            <RadioButton id={"invioCampioneNazionaleNo"} name={"invioCampioneNazionale"}
                                         label={t("SchedaSpecialeMorbillo.no")}
                                         style={{color: "black", fontSize: "16px"}}
                                         newRadio={true}
                                         onClick={this.riceviValore}
                                         smallLabel={true} value={"2"}
                                         checked={this.state.confermaDiLaboratorio.invioCampioneNazionale === "2"}>
                            </RadioButton>
                        </div>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col-lg-6"}>
                        <p style={{fontSize: "16px", fontWeight: "bold", marginTop: "0.5rem"}}>
                            {t("SchedaSpecialeMorbillo.dataInvio")}
                            {this.state.confermaDiLaboratorio.invioCampioneNazionale === "1" ?
                                <span className={styles.mandatoryColor}>*</span> : ""}
                        </p>
                    </div>
                    <div className={"col-lg-3"}>
                        <Calendar
                            id={"dataInvioCampioneNazionale"}
                            value={this.state.confermaDiLaboratorio.dataInvioCampioneNazionale}
                            field={"dataInvioCampioneNazionale"}
                            newCalendar={true}
                            disabled={this.state.confermaDiLaboratorio.invioCampioneNazionale === "1" ? false : true}
                            onChange={this.riceviValore}
                            errorMessage={Utils.replaceContentString(t("Messages.ERR_01_01_0B_0A"), "<nome campo>", t("SchedaSpecialeMorbillo.dataInvio"))}
                            error={(this.state.confermaDiLaboratorio.dataInvioCampioneNazionale === "" || this.state.confermaDiLaboratorio.dataInvioCampioneNazionale == null) ? false :
                                Utils.isDateInValid(Utils.transformDateForBackend(this.state.confermaDiLaboratorio.dataInvioCampioneNazionale), "-")
                            }
                        >
                        </Calendar>
                    </div>
                </div>
            </div>
        )

        return (
            <div style={{marginTop: "1rem"}}>
                <h6>{t("SchedaSpecialeMorbillo.confermaDiLaboratorio")}</h6>
                <hr className={styles.hr}/>
                <div className={"container"}>
                    <ConfermaDiLaboratorioMorbillo updateConferme={this.updateConferme}
                                                   segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>
                </div>
                <div className={"container"}>
                    <ConfermaDiLaboratorioRosolia updateConferme={this.updateConferme}
                                                  segnalazioneCopia={this.props.segnalazioneCopia ? this.props.segnalazioneCopia : ""}/>
                </div>

                {questionario}
            </div>
        );
    }

}

export default withTranslation('common')(confermaDiLaboratorio)
